import React from "react";
import { useThemeContext } from "context/ThemeContext";
import styled from "styled-components";
import { ArrowDown } from "components/Icons";
import StepQuestionText from "components/styled/StepQuestionText.styled";
import { breakpoints } from "theme/themes";

export const StyleScrollDownText = styled.div`
  margin-top: 2rem;

  .text {
    display: inline;
  }

  span {
    color: ${({ theme }) => theme.colors.primary};
    font-family: ${({ theme }) => theme.fonts.fontHeavy};
  }

  button {
    cursor: pointer;
  }

  svg {
    margin-left: 10px;
    width: 24px;
    display: inline-block;
    vertical-align: text-top;
    animation: pulse 2s infinite;

    @media ${breakpoints.medium} {
      width: 44px;
    }
  }

  @keyframes pulse {
    0% {
      transform: scale(0.9);
    }

    50% {
      transform: scale(1.2);
    }

    100% {
      transform: scale(0.9);
    }
  }
`;

const ScrollDownText = ({ text, handleArrowDownClick }) => {
  const { theme } = useThemeContext();
  return (
    <StyleScrollDownText className="scroll-down-text">
      <StepQuestionText className="text" dangerouslySetInnerHTML={{ __html: text }}></StepQuestionText>
     <button onClick={handleArrowDownClick}> <ArrowDown color={theme.colors.primary} /></button>
    </StyleScrollDownText>
  );
};

export default ScrollDownText;
